import initSlider from './slider';

/**
 *
 * @param {HTMLElement} root
 * @param {{}?} callbacks
 * @constructor
 */
export default function Slider(root, callbacks) {
    initSlider(root, callbacks);
}
